import { watchEffect, type Directive } from 'vue'
import { usePermissions, type Capability } from '@/composables/permissions'

/**
 * v-can="'master'" hides the element unless the signed-in role may do that (see
 * composables/permissions.ts); v-can.disable keeps it visible but unclickable (the period
 * lock also shows whether the period is open). It follows role and pay-period changes while mounted.
 */
export const vCan: Directive<HTMLElement, Capability> = {
  mounted(el, binding) {
    const { can } = usePermissions()
    ;(el as any).__vCanStop = watchEffect(() => {
      const ok = can(binding.value)
      if (binding.modifiers.disable) {
        el.style.pointerEvents = ok ? '' : 'none'
        if (ok) el.removeAttribute('disabled')
        else el.setAttribute('disabled', '')
      } else if (ok) el.style.removeProperty('display')
      else el.style.setProperty('display', 'none', 'important')
    })
  },
  unmounted(el) {
    ;(el as any).__vCanStop?.()
  }
}
